export default "__VITE_ASSET__e91d0b28__"